package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_06_23_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes who are battling a Pitmaster in the back of a dark cavern.  Soon after the Pitmaster falls, a Broodguard enters from the West and yells “Intruders, bring EVERYONE!” A Yuan-ti Anathema and Yuan-ti Abomination enters from the east. The Anathema casts a spell which cast Bigs and Caper into darkness. Our heroes hear more creatures heading their way. A Broodguard enters from the mid-west and a Broodguard and Pitmaster enter from the lower-west. Falorn casts a healing spell during combat. Tuesday casts an epic chain lightning chaos bolt that chains across the battlefield. The heavily wounded Anathema flees down a tunnel and Bigs pursues it to finish it off.")
    }
}
